<script>
import ModelEdit from "../models/edit";
import FormsModel from "@/components/forms/tickets";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit Tickets",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('tickets.singular')) }},
    resourceRoute: {default: 'tickets'},
    modelVariable: {default: 'ticket'},
    form: {default() { return FormsModel; }},
    denyDelete: {type: Boolean, default: true}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('tickets.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  methods: {
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/tickets/${this.$route.params.key}`, {
        params: {
          with: [
          ].join(',')
        }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = {
          ...data,
        };
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    },
    update(value) {
      return this.$axios.put(`/tickets/${this.$route.params.key}`, value);
    },
  },
}
</script>
